exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".cameraContainer{display:inline-block}.wrapper{height:100%;width:100%;overflow:hidden;display:flex;justify-content:center}.round{border-radius:50%}", "",{"version":3,"sources":["styles.scss"],"names":[],"mappings":"AACA,iBACE,oBAAA,CAGF,SACE,WAAA,CACA,UAAA,CACA,eAAA,CACA,YAAA,CACA,sBAAA,CAGF,OACE,iBAAA","file":"styles.scss","sourcesContent":["$theme: zam;\n.cameraContainer {\n  display: inline-block; // we want the buttons to fit in the middle.\n}\n\n.wrapper {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n}\n\n.round {\n  border-radius: 50%;\n}\n"]}]);

// Exports
exports.locals = {
	"cameraContainer": "cameraContainer",
	"wrapper": "wrapper",
	"round": "round"
};